
export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white font-playfair">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center justify-center w-full md:w-auto">
              <h1>
                <a href="/">
                  <img 
                    src="https://static.readdy.ai/image/a19705f045df358eda503236ce656b36/846ee1e93f81f94b53dc3e9fa39ac791.png" 
                    alt="VTC Legal - Fractional General Counsel for AI and Tech Companies" 
                    className="h-16 w-auto"
                  />
                </a>
              </h1>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h1 className="text-4xl font-bold text-gray-900 mb-8 font-playfair">Privacy Policy</h1>
        <p className="text-sm text-gray-600 mb-12 font-inter">Effective Date: January 1, 2026</p>

        <div className="prose max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Introduction</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              VTC Legal ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website vtclegal.com and use our services.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Information We Collect</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Personal Information</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              We may collect personal information that you voluntarily provide, including:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6 font-inter">
              <li>Name and contact information (email address, phone number)</li>
              <li>Company information and job title</li>
              <li>Communication preferences</li>
              <li>Information provided in consultations or correspondence</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Automatically Collected Information</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6 font-inter">
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>IP address and location data</li>
              <li>Pages visited and time spent on our website</li>
              <li>Referral sources</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">How We Use Your Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6 font-inter">
              <li>Provide and improve our legal services</li>
              <li>Communicate with you about our services</li>
              <li>Respond to your inquiries and requests</li>
              <li>Send relevant legal updates and insights</li>
              <li>Analyze website usage and improve user experience</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Information Sharing and Disclosure</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              We do not sell, trade, or rent your personal information to third parties. We may share information in the following circumstances:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6 font-inter">
              <li>With your explicit consent</li>
              <li>To comply with legal requirements or court orders</li>
              <li>To protect our rights, property, or safety</li>
              <li>With trusted service providers who assist in operating our website (subject to confidentiality agreements)</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Attorney-Client Privilege</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              Information shared with us in the course of an established attorney-client relationship is protected by attorney-client privilege and will be kept strictly confidential in accordance with professional rules of conduct and applicable law.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Data Security</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Your Rights</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              Depending on your location, you may have the following rights regarding your personal information:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6 font-inter">
              <li>Access to your personal information</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of your personal information</li>
              <li>Objection to processing</li>
              <li>Data portability</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Cookies and Tracking Technologies</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              Our website may use cookies and similar tracking technologies to enhance your experience. You can control cookie preferences through your browser settings.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Changes to This Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              We may update this Privacy Policy periodically. We will notify you of any material changes by posting the new policy on this page with an updated effective date.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Contact Us</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              If you have questions about this Privacy Policy or our privacy practices, please contact us at:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 font-inter"><strong>Email:</strong> sergio@vtclegal.com</p>
              <p className="text-gray-700 font-inter"><strong>Phone:</strong> (443) 306-7487</p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 text-gray-900 py-20 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-600 text-sm font-inter">
            © 2026 VTC Legal. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
